<template>
    <div class="apply-div" v-if="isShow" @click="openApply">
        <img :src="url">
    </div>
</template>

<script>
export default {
  name: 'ApplyUse',
  data () {
    return {
      isShow: false
    }
  },
  props: {
    url: {
      type: String,
      default: require('../../../static/images/apply_use.gif')
    },
    top: {
      type: Number,
      default: 350
    },
    bottm: {
      type: Number,
      default: 1025
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    window.addEventListener('scroll', this.moveApplyUse, true)
  },
  destroyed () {
    window.removeEventListener('scroll', this.moveApplyUse)
  },
  methods: {
    moveApplyUse () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > this.top) {
        this.isShow = true
      } else {
        this.isShow = false
      }
      if (scrollTop > this.bottm) {
        this.isShow = false
      }
      // console.log(scrollTop)
    },
    openApply () {
      this.$emit('openApply')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .apply-div{
      cursor: pointer;
      width:260px;
      height:110px;
      position: fixed;
      z-index: 9999;
      right: 0px;
      bottom: 80px;
    }
    .apply-div img{
      width: 100%;
      height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/applyUse/applyUse.vue